import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import { getValue } from "../utils/Fuc";
import store from "@/store/index";
import { AUTH } from "@/store/actions";
 import local from "@/utils/store";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

Vue.use(VueRouter);

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
});

//鉴权
router.beforeEach((to, from, next) => {

	NProgress.start();
    const requireLogin = getValue(to.meta, "requireLogin", false);
	const requireAuth = getValue(to.meta, "requireAuth", false);
	const title = getValue(to.meta, "title", null);
	if (title !== null) {
		window.document.title = title;
	}

	//检查登录权限
	if (requireLogin) {
		const token = local.get("token");
		if (!token) {
			NProgress.done();
			next({
				path: "/login",
			});
		}
	}
	//检查路由权限
	if (requireAuth) {
		console.log(to.path)
		//如果未从后端获取权限，则先获取权限

		// const { auth } = store.state;
		// console.log(auth.is_request)

		store.dispatch(AUTH.NAMESPACE + "/" + AUTH.REQUEST_AUTH).then(() => {
			if (!store.getters["auth/checkRoute"](to.path)) {
				// console.log('没权限');
				NProgress.done();
				next({
					path: "forbidden",
				});
			} else {
				NProgress.done();
				next();
			}
		});

		// if (!auth.is_request) {
		// 	// console.log(222)
		// 	store.dispatch(AUTH.NAMESPACE + "/" + AUTH.REQUEST_AUTH).then(() => {
		// 		if (!store.getters["auth/checkRoute"](to.path)) {

		// 			NProgress.done();
		// 			next({
		// 				path: "forbidden",
		// 			});
		// 		} else {
		// 			NProgress.done();
		// 			next();
		// 		}
		// 	});
		// } else {
		
		// 	if (!store.getters["auth/checkRoute"](to.path)) {
		// 		NProgress.done();
		// 		next({
		// 			path: "forbidden",
		// 		});
		// 	} else {
		// 		NProgress.done();
		// 		next();
		// 	}
		// }
	} else {
		NProgress.done();
		next();
	}
});

router.afterEach(() => {});

export default router;
